"use client";

import { Field, FieldError, FieldLabel } from "@repo/ui/form-fields";
import { type CodeValue, fromCodeableConcept, toCodeableConcept } from "@/shared/forms/code-value";
import { useFieldContext } from "@/shared/forms/form-context";
import { IcdCodePicker } from "@/shared/pickers/icd-code-picker";

export interface IcdCodeFieldProps {
  label?: string;
  placeholder?: string;
}

/**
 * Form state holds the flat `CodeValue`, not `CodeableConcept` — see
 * `code-value.ts` for why. The picker speaks FHIR, so the two are bridged here,
 * at the single boundary between them.
 */
export function IcdCodeField({ label, placeholder }: IcdCodeFieldProps) {
  const field = useFieldContext<CodeValue | undefined>();

  return (
    <Field errors={field.state.meta.errors} isTouched={field.state.meta.isTouched}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <IcdCodePicker
        value={field.state.value ? toCodeableConcept(field.state.value) : undefined}
        onChange={(v) => {
          field.handleChange(fromCodeableConcept(v));
          field.handleBlur();
        }}
        placeholder={placeholder}
      />
      <FieldError />
    </Field>
  );
}
